import Api from '../utils/Api';
import Config from '../config/Config';

class SeguroService {
  constructor() {
    this.url = Config.URL_SERVICE;
    this.api = new Api({ url: this.url });
    this.api.createEntities([{ name: 'seguros' }]);
  }

  buscar() {
    return this.api.endpoints.seguros
      .get()
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  
}

export default new SeguroService;